import styled from 'styled-components';

export const EmptyState = styled('div')`
  padding: ${({ theme }) => theme.x1spacePx}px;
`;
